module.exports = __webpack_public_path__ + "img/fi-br-trash.035a212f.svg";